import React, { useState, useRef, useMemo, useEffect } from 'react';
import JoditEditor from 'jodit-react';
import { useParams } from 'react-router-dom';

const DeanJoditEditor = ({ placeholder, subTitle, editorContent, onContentChange }) => {
	const {id} = useParams();
	const editor = useRef(null);
	const [content, setContent] = useState(editorContent);


	const insertDefault = (subTitle) => {
		if (subTitle === "extensionOfNBAAccrediation") {
			setContent("")
		} else if (subTitle === "visitOfNBACommittee") {
			setContent("")
		} else if(subTitle === "studentMalpracticeDetails"){
            setContent("")
        } else if(subTitle === "toConsiderResultsOfVariousUGandPG"){
            setContent("")
        }
	};

	const insertImage = (resp) => {
		const imageUrl = `${process.env.REACT_APP_BASE_URL}/api/object/${resp.id}`;
		const imgHtml = `<img src="${imageUrl}" alt="Image" style="max-width: 100%; height: auto;" />`;
		const currentContent = editor.current?.value || content;  
		const updatedContent = currentContent + imgHtml;
		setContent(updatedContent);
		onContentChange(updatedContent);
	};
	
	// Memoized configuration for JoditEditor
	
	const config = useMemo(() => ({
		readonly: false,
		placeholder: placeholder || '',
		toolbar: {
			buttons: [
				'bold',
				'italic',
				'underline',
				'image', // Include the image button
				'|', // Divider
				'source',
			],
		},
		uploader: {
			insertImageAsBase64URI: false,
			url: `${process.env.REACT_APP_BASE_URL}/api/report/${id}/upload`,
			headers: {
				Authorization: `Bearer ${localStorage.getItem("jwt")}`
			},
			method: 'POST',
			prepareData: (formData) => {
				const files = formData.getAll('files[0]'); 
				formData.delete('files[0]'); 
			
				files.forEach((file) => {
					formData.append('file', file); 
				});
				return formData;
			}
			,
			isSuccess: (resp) => {
				return resp;
			},
			process: (resp) => {
				console.log('File uploaded successfully:', resp);
				insertImage(resp);
				return {}; 
			},
			error: (e) => {
				console.error('Upload error', e);
			}
		},
		events: {
			beforeImage: function(current) {
				return false; 
			},
			'errorMessage': function(message) {
				console.error(message);
			}
		}
	}), [placeholder, id]);

	useEffect(() => {
		if (editorContent) {
		    setContent(editorContent);
		} else{
            insertDefault(subTitle);
        }
	}, [subTitle]);

	const handleContentChange = (newContent) => {
		setContent(newContent);
		onContentChange(newContent);
	  };

	return (
		<JoditEditor
			ref={editor}
			value={content}
			config={config}
			tabIndex={1}
			onBlur={(newContent) => handleContentChange(newContent)}
			onChange={(newContent) => {}}
		/>
	);
};

export default DeanJoditEditor;
